import type { Translations } from '../../types'

const mediaMessages: Translations = {
  "media.title": "Libreria media",
  "media.eyebrow": "Contenuti",
  "media.subtitle": "Organizza immagini, anteprime e risorse del tuo store.",
  "media.searchPlaceholder": "Cerca per nome, titolo o testo alternativo...",
  "media.tab.library": "Libreria",
  "media.tab.trash": "Cestino",
  "media.count.one": "1 elemento",
  "media.count.many": "{{count}} elementi",
  "media.grid.empty": "Nessun media corrisponde alla ricerca.",
  "media.grid.emptyDescription": "Prova a modificare la ricerca o carica un nuovo file.",
  "media.trash.empty": "Il cestino è vuoto",
  "media.trash.emptyDescription": "I media eliminati resteranno qui finché non li ripristini o li elimini definitivamente.",
  "media.actions.copyUrl": "Copia URL",
  "media.actions.download": "Scarica",
  "media.actions.moveToTrash": "Sposta nel cestino",
  "media.actions.restore": "Ripristina",
  "media.actions.deleteForever": "Elimina definitivamente",
  "media.actions.close": "Chiudi",
  "media.actions.preview": "Apri anteprima",
  "media.actions.uploading": "Caricamento file",
  "media.meta.file": "File",
  "media.meta.size": "Dimensione",
  "media.meta.dimensions": "Dimensioni",
  "media.meta.mime": "Formato",
  "media.toast.restored": "Media ripristinato",
  "media.toast.restoreError": "Ripristino fallito",
  "media.toast.deletedForever": "Media eliminato definitivamente",
  "media.actions.rename": "Rinomina",
  "media.actions.save": "Salva",
  "media.actions.cancel": "Annulla",
  "media.actions.open": "Apri",
  "media.actions.generated": "Varianti WebP",
  "media.actions.deleteSelected": "Elimina selezionati",
  "media.selected": "Selezionato",
  "media.tapSelect": "Seleziona",
  "media.actions.delete": "Elimina",
  "media.toast.loadError": "Errore nel caricamento media",
  "media.toast.renameError": "Rinomina fallita",
  "media.toast.renamed": "Media rinominato",
  "media.toast.deleted": "Media eliminato",
  "media.toast.deleteError": "Eliminazione fallita",
  "media.empty": "Nessun media caricato.",
  "media.upload.title": "Trascina qui le immagini",
  "media.upload.subtitle": "Le immagini saranno compresse in WebP dalla pipeline media del CMS",
  "media.upload.button": "Seleziona file",
  "media.toast.uploaded": "Upload completato",
  "media.toast.uploadError": "Errore durante l'upload",
  "media.toast.saved": "Media aggiornato",
  "media.actions.saveMeta": "Salva metadati"
}

export default mediaMessages
